export default __webpack_public_path__ + "static/media/arkav.12a1de2c.png";